<div appInViewTrigger [observeParent]="true" [triggerOn]="uiPlacement.Top" (visibleChanged)="onVisible($event)">
    <mat-progress-spinner [diameter]="32" [strokeWidth]="4" mode="indeterminate"></mat-progress-spinner>
</div>
